import firebase from "firebase";
import "firebase/firestore";

let firebaseConfig = {
  apiKey: "AIzaSyAStd08wSWHspai8UeRqL90K5lS6AiRXAk",
  authDomain: "dothings-74a00.firebaseapp.com",
  databaseURL: "https://dothings-74a00.firebaseio.com",
  projectId: "dothings-74a00",
  storageBucket: "dothings-74a00.appspot.com",
  messagingSenderId: "251107485349",
  appId: "1:251107485349:web:130b79d9f5c632eacd0f4c",
  measurementId: "G-QTL7YJRR3Y"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const fireStore = firebaseApp.firestore();

export default fireStore;
